/**
 * 解析 URL query 字符串，保留当前渠道参数读取所需的字符串键值行为。
 */
function parseQueryString(query: string) {
  const map: Record<string, string> = {};
  const params = new URLSearchParams(query);

  params.forEach((value, key) => {
    map[key] = value;
  });

  return map;
}

/**
 * 合并 search 与 hash 中的渠道参数，hash 参数保持后写覆盖的历史行为。
 */
function getQueryMap() {
  const map: Record<string, string> = {};
  Object.assign(map, parseQueryString(window.location.search.split('?')[1] || ''));
  Object.assign(map, parseQueryString(window.location.hash.split('?')[1] || ''));
  return map;
}

// url query keys
const QUERY_KEYS = {
  CHANNEL: 'channel', // 渠道投放的渠道标识
  FIRST_URL: 'first_url', // 渠道投放的落地页url
  MATRIX_CHANNEL: 'matrix_channel', // 矩阵互推跳转标识
  // FROM: 'from', // 访问入口来源
};

let isInit = false;
/**
 * 初始化渠道参数，first_url 记录首次真实落地页，避免解析 first_url 参数时截断后续 query
 */
export const initChannel = () => {
  const dict = getQueryMap();

  // ATTENTION: 先存到 sessionStorage 避免后续页面跳转，追踪信息丢失
  if (dict[QUERY_KEYS.MATRIX_CHANNEL]) {
    const value = dict[QUERY_KEYS.MATRIX_CHANNEL] || '';
    window.sessionStorage.setItem(QUERY_KEYS.MATRIX_CHANNEL, value);
  }

  if (dict[QUERY_KEYS.CHANNEL]) {
    const channelValue = dict[QUERY_KEYS.CHANNEL] || '';
    const firstURLValue = window.sessionStorage.getItem(QUERY_KEYS.FIRST_URL) || window.location.href;

    window.sessionStorage.setItem(QUERY_KEYS.CHANNEL, channelValue);
    window.sessionStorage.setItem(QUERY_KEYS.FIRST_URL, firstURLValue);
  }

  isInit = true;
};

type ValueOf<T> = T[keyof T];
const getSessionStorageValueByKey = (key: ValueOf<typeof QUERY_KEYS>) => {
  if (!isInit) {
    throw new Error('请先initChannel');
  }
  const value = window.sessionStorage.getItem(key) || '';

  if (value) {
    return decodeURIComponent(value);
  }

  return decodeURIComponent(window.sessionStorage.getItem(key) || '');
};

export const getChannel = () => {
  return getSessionStorageValueByKey(QUERY_KEYS.CHANNEL);
};

export const getFirstURL = () => {
  return getSessionStorageValueByKey(QUERY_KEYS.FIRST_URL);
};

// export const getFrom = () => {
//   return getSessionStorageValueByKey(QUERY_KEYS.FROM);
// };

export const getMatrixChannel = () => {
  return getSessionStorageValueByKey(QUERY_KEYS.MATRIX_CHANNEL);
};
